export { default as Welcome } from './Welcome';
